import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  IconButton,
  CircularProgress,
  Snackbar,
} from "@mui/material";
import { Column } from "primereact/column";
import Tables from "./widgets/tables";
import { useDispatch, useSelector } from "react-redux";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  ApiSuccess,
  GetResetPasswordData,
  UpdatePassword,
  setFilters,
  setPage,
  setRowsPerPage,
  setRecord,
} from "../redux/slices/ResetPassword";
import { keyframes } from "@emotion/react";
import moment from "moment";
import "jspdf-autotable";
import DownloadData from "./widgets/downloaddata";
import ButtonTabs from "./widgets/buttontabs";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { ResetPasswordChannel, ablyClient } from "../lib/socket";
import { toast } from "react-toastify";
import LazyTable from "./widgets/lazytable";
const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Restpassword = () => {
  const dispatch = useDispatch();
  const { page, data, rowsPerPage, totalRequests, loading, filters } =
    useSelector((state) => state.resetPassword);

  const [loadingId, setLoadingId] = useState(null);
  const fetchResetPasswordData = () => {
    dispatch(GetResetPasswordData(page, rowsPerPage, filters));
  };

  useEffect(() => {
    fetchResetPasswordData();
  }, [dispatch, page, rowsPerPage, filters]);

  const handleChangePage = (event, newPage) => {
    dispatch(setPage(newPage));
  };

  const handleChangeRowsPerPage = (event) => {
    dispatch(setRowsPerPage(event.target.value, 10));
    dispatch(setPage(0));
  };

  const statusBodyTemplate = (rowData) => {
    return (
      <Box
        className="capitalize"
        sx={{
          color: rowData.bl == 3 ? "red" : "green",
          fontWeight: "bold",
        }}
      >
        {rowData.bl == 3 ? "Pending" : "Deposit"}
      </Box>
    );
  };
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    setOpenSnackbar(true);
  };

  const handleApprove = async (params) => {
    setLoadingId(params?._id);
    const payload = {
      ghid: params?._id,
      uid: params?.user_id,
      gameid: params?.gameid,
      extra: params?.extra,
    };
    await dispatch(UpdatePassword(payload));
    await ResetPasswordChannel(
      "admin-reset",
      params?._id,
      "admin-456",
      "private-reset"
    );
    setLoadingId(null);
  };
  useEffect(() => {
    const channel = ablyClient.channels.get("admin-reset");

    const messageHandler = async (message) => {
      const { senderId, receiverId, text } = message.data;

      if (senderId) {
        // setMessages((prev) => [...prev, { senderId, receiverId, text }]);
        // fetchResetPasswordData();
      }
    };

    channel.subscribe("private-reset", messageHandler);

    return () => {
      channel.unsubscribe("private-reset", messageHandler);
    };
  }, [dispatch]);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const headers = [
    "User ID",
    "User Name",
    "Game Name",
    "Before Balance",
    "Update Amount",
    "After Balance",
    "Transaction Type",
    "Date",
    "Status",
  ];

  const tableData = data?.map((row) => [
    row.userid || "N/A",
    row.userName || "N/A",
    row.beforeBalance || "N/A",
    row.updateAmount || "N/A",
    row.afterBalance || "N/A",
    row.transactionType || "N/A",
    row.date || "N/A",
    row.status || "N/A",
  ]);

  const handleEdit = (row, newValue) => {
    dispatch(setRecord({ row, extra: newValue }));
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          my: 4,
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="h5">Reset Password Request</Typography>
          <IconButton
            onClick={fetchResetPasswordData}
            disabled={loading}
            sx={{
              animation: loading ? `${rotate} 1s linear infinite` : "none",
              backgroundColor: "#3f51b5",
              color: "white",
              "&:hover": {
                backgroundColor: "#303f9f",
              },
              "&:disabled": {
                backgroundColor: "#e0e0e0",
              },
            }}
          >
            <RefreshIcon />
          </IconButton>
        </Box>
        <DownloadData
          headers={headers || []}
          tableData={tableData || []}
          fileName={"Reset-Password-Requests"}
        />
      </Box>
      {/* <Box>
        <ButtonTabs />
      </Box> */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        message="Please select an export format."
        onClose={() => setOpenSnackbar(false)}
      />
      <LazyTable
        data={data}
        page={page}
        rowsPerPage={rowsPerPage}
        totalRecords={totalRequests}
        loading={loading}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        onFilterChange={(filters) => {
          dispatch(setFilters(filters));
        }}
        columns={[
          { field: "name", headerName: "User Name", filter: true },
          {
            field: "gamename",
            headerName: "Game Name",
            filter: true,
          },
          {
            field: "username",
            headerName: "Game ID",
            filter: true,
          },
          {
            field: "extra",
            headerName: "New Password",
            filter: true,
            render: (rowData, index) => (
              <UsernameCell
                rowData={rowData}
                field="extra"
                onEdit={handleEdit}
              />
            ),
          },
          {
            field: "createdAt",
            headerName: "Date",
            filter: true,
            render: (rowData) => moment(rowData?.createdAt).format("L LT"),
          },

          {
            field: "actions",
            headerName: "Actions",
            render: (rowData, index) => (
              <Box display="flex" gap={1}>
                <Button
                  variant="contained"
                  color="success"
                  size="small"
                  disabled={loadingId === rowData._id}
                  loading={loadingId === rowData._id}
                  onClick={() => handleApprove(rowData, index)}
                >
                  Approve
                </Button>
              </Box>
            ),
          },
        ]}
      />
    </>
  );
};

const UsernameCell = ({ rowData, field, onEdit }) => {
  const [value, setValue] = useState(rowData[field]);

  const dispatch = useDispatch();

  useEffect(() => {
    setValue(rowData[field]);
  }, []);
  const safeCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => toast.success("Copied to clipboard!"))
      .catch(() => toast.error("Failed to copy!"));
  };

  const handleChange = (e) => {
    setValue(e.target.value);

    onEdit(rowData, e.target.value);
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      {rowData.active === 1 ? (
        value
      ) : (
        <input
          maxLength={15}
          type="text"
          value={value}
          onChange={handleChange}
        />
      )}

      <span
        className="text-md text-gray-800 cursor-pointer"
        onClick={() => safeCopy(value)}
      >
        <ContentCopyIcon className="ml-1" fontSize="inherit" />
      </span>
    </Box>
  );
};
export default Restpassword;
